<template>
    <body class="white-bg">
        <div class="research">
            <div id="start" class="ibox page-full ">
                <div class="r-header">SK텔레콤 노동조합</div>
                <div></div>
                <div class="r-box no-borders white-bg" style="padding: 10px;">
                    <div>
                        <div style="border: 5px double #337AB7; padding: 1px;">
                            <b>
                                <br><br>
                                <font size="6">SK텔레콤 노동조합</font>
                            </b>
                            <br><br><br>
                            <div align="center" style="margin: 0px 0px 10px; padding: 1px; background-color: rgb(198, 217, 241);">
                                <b><font color="black" size="4">일하는 노동조합</font></b>
                                <br/>
                                <b><font color="black" size="4">성과내는 노동조합</font></b>
                                <br/>
                                <b><font color="black" size="4">함께하는 노동조합</font></b>
                            </div>
                            <br/>
                        </div>
                        <br>
                    </div>
                    
                    <div class="r-font-size mb-4" style="margin-top: 10px;">
                        <br/><br/>
                        <button class="btn btn-success r-btn-width r-btn-blue" @click="next()">조합 홈페이지 가기</button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
export default {
  name: 'home',
  props: {
    //msg: String
  },
  data() {
    return {
    }
  },
  mounted() {
      window.scrollTo(0, 0)
  },
  methods: {
      next() {
          window.location.href = "http://www.sktunion.com"
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
